/**
 * Mobile Filter drawer for the Shop All collection view.
 *
 * Extends Dawn's MenuDrawer (global.js) exactly like HeaderDrawer does, so
 * open/close, Esc, focus trapping and the body scroll lock
 * (overflow-hidden-tablet, released at 990px) all come for free.
 *
 * Adds: radio selection → "View N results" button (href + count), and
 * re-opens the default-open group cards after MenuDrawer strips `open` from
 * every nested <details> when the drawer closes.
 */
class WonderlyShopAllFilter extends MenuDrawer {
  constructor() {
    super();
    this.cta = this.querySelector('.wonderly-shop-all-filter__cta');
    this.addEventListener('change', (event) => {
      if (event.target.matches('.wonderly-shop-all-filter__input')) this.updateCta();
    });
    // Tap on the dimmed backdrop (outside the panel) closes the drawer.
    this.addEventListener('click', (event) => {
      if (event.target.matches('.wonderly-shop-all-filter__overlay')) {
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      }
    });
    this.updateCta();
  }

  updateCta() {
    if (!this.cta) return;
    const selected = this.querySelector('.wonderly-shop-all-filter__input:checked');
    if (!selected) {
      this.cta.removeAttribute('href');
      this.cta.setAttribute('aria-disabled', 'true');
      this.cta.textContent = this.cta.dataset.labelEmpty;
      return;
    }
    const count = selected.dataset.count;
    this.cta.href = selected.value;
    this.cta.removeAttribute('aria-disabled');
    this.cta.textContent = count
      ? this.cta.dataset.labelTemplate.replace('[count]', count)
      : this.cta.dataset.labelEmpty;
  }

  openMenuDrawer(summaryElement) {
    super.openMenuDrawer(summaryElement);
    this.querySelectorAll('.wonderly-shop-all-filter__group[data-default-open="true"]').forEach((group) => {
      group.setAttribute('open', '');
    });
  }
}

customElements.define('wonderly-shop-all-filter', WonderlyShopAllFilter);
